<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-dialog v-model="chooseProductDialog" persistent max-width="600px">
    <v-container fluid grid-list-sm>
      <v-toolbar color="White">
        <v-toolbar-title class="headline">{{$t('navigation_products')}}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-spacer></v-spacer>
      <v-card class="my-1" :elevation="2">
        <v-data-table
          :headers="headers"
          :items="tableData"
          :items-per-page="itemsPerPage"
          :footer-props="{itemsPerPageOptions: [10,20,30,50]}"
          :dense="false"
          class="elevation-1"
          show-select
          v-model="selected"
          :single-select="false"
          sort-by="name"
          :loading="tableDataLoading"
          loading-text="'Data is currently being loaded, please wait...'">

          <template slot="items" slot-scope="props">
            <td>{{ props.item.date }}</td>
          </template>

          <!-------------------------------- ## NO DATA ## ----------------------------------->
          <template v-slot:no-data>
            <div class="text-xs-center">
              <v-alert :value="showErrorMessage" color="error" icon="mdi-alert-circle-outline">
                {{errorMessage}}
              </v-alert>
            </div>
          </template>
        </v-data-table>
        <v-card-actions class="white" align="right">
          <div class="flex-grow-1"></div>
          <v-btn class="mr-4" text color="primary" dark @click="closeDialog()">
            {{$t('close')}}
          </v-btn>
          <v-btn class="mr-4" text color="primary" dark @click="add()">
            {{$t('add')}}
          </v-btn>
        </v-card-actions>
      </v-card>
      <template>
        <!---------------------------------- Snackbar  ----------------------------------------->
        <v-snackbar
          v-model="snackbar.show"
          :bottom=true
          :right=true
          :color="snackbar.color"
          :timeout="snackbar.timeout">
          {{ snackbar.text }}
          <v-btn dark text @click="snackbar.show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-snackbar>
      </template>
    </v-container>
  </v-dialog>

</template>

<script>
  import axios from 'axios'
  import {readTableData} from "../../statics/DataTableFunctions";

  export default {
    props: {
      chooseProductDialog: false,
      chooseProductDialogData: null,
    },
    name: "ChooseProduct",
    data: function () {
      return {
        selected: [],
        defaultActive: '',
        snackbar: {
          color: 'success',
          show: false,
          text: '',
          timeout: 3000,
        },
        itemsPerPage: 10,
        rowsPerPageItems: [10, 15, 30, 50],
        tableDataLoading: true,
        tableData: null,
        enabledSearch: true,
        showErrorMessage: false,
        errorMessage: '',
        filters: {
          name: '',
          address: '',
          pib: '',
          pdv: '',
          isActive: '',
        },
        selectedLetter: null,
        letters: [],
        products: [],
      }
    },
    methods: {
      readTableData,
      findPartnerById(id) {
        if (this.selected.length > 0) {
          for (let i = 0; i < this.selected.length; i++) {
            if (this.selected[i].id === id) {
              return i;
            }
          }
          return -1;
        } else {
          return -1;
        }
      },
      select(item) {
        this.selected = item
        this.selectedId = item.id
      },
      closeDialog() {
        this.$emit('close')
      },
      add(){
        this.$emit('add', this.selected)
      }
    },
    created() {
      this.readTableData('products');
    },
    computed: {
      headers() {
        return [
          {
            text: this.$t('products.name'),
            name: 'name',
            align: 'left',
            sortable: true,
            value: 'name'
          },
        ]
      },
      activeObjects() {
        return [
          {value: "", text: this.$t('all')},
          {value: 1, text: this.$t('active')},
          {value: 0, text: this.$t('not_active')},
        ]
      },
    },
    watch: {
      chooseProductDialog: function (val) {
        if (val) {
            this.selected = this.chooseProductDialogData;
        }
      },
    },
  }
</script>

<style scoped/>
